import { useDispatch, useSelector } from "react-redux";
import { Sidebar_Handle_Open } from "../Actions/LoginAction";
import { HiUserCircle } from "react-icons/hi";

import { FaRegUserCircle } from "react-icons/fa";

export default function TopBar({ Heading }) {
  const dispatch = useDispatch();
  const { sidebar } = useSelector((state) => state.Sidebar_Reducer);
  const { UserDet } = useSelector((state) => state.LoginReducer);
  const handleSideBar = (e) => {
    e.preventDefault();
    dispatch(Sidebar_Handle_Open(!sidebar));
  };

  return (
    <>
      <nav>
        <div className="sidebar-button">
          <i onClick={handleSideBar} className="bx bx-menu sidebarBtn"></i>
          <span className="dashboard">
            {Heading ? Heading : "Merchant Dashboard"}
          </span>
        </div>

        <div
          className="profile-details"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            fontSize: "16px",
          }}
        >
          <FaRegUserCircle /> <span>{UserDet?.Name}</span>
        </div>
      </nav>
    </>
  );
}
